import AuthHelper from "../../utils/AuthHelper";
import { hashHistory } from 'react-router';

function checkAuth() {
  if (!AuthHelper.isAuthenticated) {
      hashHistory.push("/login");
  }
}

module.exports = {
  path: 'app',
  onEnter: checkAuth,
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        // require('./routes/instagram'),
        require('./routes/products'),
        require('./routes/banners'),
        require('./routes/menu'),
        require('./routes/slugs'),
        require('./routes/pages'),
        require('./routes/dashboard'),
        require('./reports'),
        require('./users'),
        require('./routes/links'),
        require('./routes/shipment-types'),
        require('./configuration'),
        require('./routes/eventLogs'),
      ]);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/MainApp'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/index.js